import { render, staticRenderFns } from "./SocialSharing.vue?vue&type=template&id=44ba11bb&scoped=true"
import script from "./SocialSharing.vue?vue&type=script&lang=ts"
export * from "./SocialSharing.vue?vue&type=script&lang=ts"
import style0 from "./SocialSharing.vue?vue&type=style&index=0&id=44ba11bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ba11bb",
  null
  
)

export default component.exports